(ns frontend.ux-overhaul.listing.fundraising-opportunity.view
  (:require [frontend.state.current-session :as session]))

(def config
  {:listing-id               "fundraising-opportunity-listing"
   :entity-type              :entity.type/fundraising-opportunity
   :route-id                 :fundraising-opportunities-grid
   :create-action-id         :create-fundraising-opportunity
   :create-label             :fundraising-opportunity-add-button
   :pipeline-attribute       :fundraising-opportunity/pipeline
   :pipeline-key             :fundraising-opportunity-pipeline
   :module                   :module/fundraising
   :route-with-pipeline-id   :fundraising-opportunities-grid-with-pipeline
   :stage-entity-type        :entity.type/opportunity-stage
   :stage-name-attribute     :opportunity-stage/name
   :stage-pipeline-attribute :opportunity-stage/pipeline
   :title                    :all-fundraising-opportunities
   :selected-pipeline        session/selected-froppo-pipeline
   :all-pipelines            session/all-froppo-pipelines
   :feature?                 session/fundraising?})
